import { createImageCell } from "./BURHistoryDom";
import {
    getJackpotImage,
    getSymbolImage,
    getSymbolName
} from "./BURHistorySymbolImages";
import { historyText } from "./BURHistoryTexts";

// Symbol image with its name as tooltip, or just the name when no image can be made
export function createSymbolCell(id: number): HTMLElement {
    return createImageCell(getSymbolImage(id), getSymbolName(id));
}

// The jackpot tier shown with its fragment texture, e.g. "Jackpot MEDIUM" as tooltip / fallback
export function createJackpotCell(tier: string): HTMLElement {
    const cell = createImageCell(
        getJackpotImage(tier),
        `${historyText("jackpot")} ${tier}`
    );
    // The CSS scales all tier texts by the same factor from their natural width, so the letters keep one size
    const img = cell.querySelector("img");
    if (img) {
        const setWidth = () =>
            img.style.setProperty("--tier-w", `${img.naturalWidth}`);
        img.complete ? setWidth() : img.addEventListener("load", setWidth);
    }
    return cell;
}
